import _axios from "../plugins/axios"
import dayjs from "dayjs"
import { useCallback, useEffect, useState } from "react"
import { generatePath, useHistory, useParams } from "react-router"
import styled from "styled-components"
import { Header, ListWrap } from "../common/components"
import { API_URL } from "../common/constant"
import ROUTES from "../common/routes"
import { Patient, Schedule } from "../common/types"

const Alert = styled.div`
  background: #ffffff;
  color: red;
  margin-top: 24px;
  font-size: 18px;
  padding: 4px;
  border: solid 2px pink;
`
export const List = styled.div`
  border: solid 1px #999999;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;  /* 一列兩組 label/value */
  & > .label,
  & > .value {
    text-align: center;
    border: solid 1px #999999;
    padding: 2px;
  }
  & > .label {
    background: #ccffcc;
  }
  & > .value {
    background: #ccffff;
  }
`;
interface Props {
  patient: Patient | null
}

export default function MakeAppointmentPage(props: Props) {
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const [schedule, setSchedule] = useState<Schedule | null>(null)
  const [reserveNo, setReserveNo] = useState<{ regReservationId: number; viewNo: number } | null>(null)

  const { patient } = props

  useEffect(() => {
    if (!patient) {
      history.replace(ROUTES.home)
      return
    }

    ;(async function getMyReservations() {
      try {
        const scheduleRes = await _axios.post(API_URL.getSchedule.replace(":id", id), { getNextViewNo: true },)
        const reserveNoRes = await _axios.post(API_URL.getReserveNo, {
          regScheduleId: id,
          isRegist: false,
        })
        setSchedule(scheduleRes.data.result)
        setReserveNo(reserveNoRes.data.result)
      } catch (error: any) {
        const errorCode = error?.response?.data?.code;
        if (errorCode === 1028) {
          window.alert("此診間預約號已滿，請選擇其餘診間或日期");
        }
        history.push(generatePath(ROUTES.scheduleList));
      }

    })()
  }, [patient, history, id])

  const onMakeAppointment = useCallback(async () => {
    const reserveRes = await _axios.post(API_URL.makeReserve.replace(":id", reserveNo!.regReservationId.toString()), {
      patientId: patient!.id,
      registType: "N", // 網路預約 type 為 N
      printFlag: false,
    })

    if (reserveRes.status !== 200) {
      // TODO: error
      return
    }

    history.push(generatePath(ROUTES.reservationDetail, { id: reserveRes.data.result.regReservationId }))
  }, [patient, reserveNo, history])

  if (!schedule || !reserveNo) {
    return <main style={{ textAlign: "center" }}>Loading...</main>
  }

  const date = dayjs(schedule.schDate)
  const isClinicClosed = schedule.flagOpenClose === "9"

  return (
    <main style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <ListWrap>
        <Header>使用者:{patient?.name}</Header>
        <List>
          <div className="label">日期</div>
          <div className="value" style={{ gridColumn: "2 / 5" }}>
            {`${date.year() - 1911}年${date.month() + 1}月${date.date().toString().padStart(2, "0")}日`}
          </div>
          <div className="label">醫師</div>
          <div className="value">{schedule.doctorName}</div>
          <div className="label">診間</div>
          <div className="value">
            {schedule.refShiftName}
            {schedule.hixClinicRoomName}
          </div>
          <div className="label">科別</div>
          <div className="value">{schedule.refDivisionName}</div>
          <div className="label">門診時間</div>
          <div className="value">
            {schedule.startTime.substring(0, 5)}~{schedule.endTime.substring(0, 5)}
          </div>
          <div className="label">預估預約號</div>
          <div className="value">{isClinicClosed ? "停診" : schedule.nextViewNo}</div>
          <div className="label">已預約人數</div>
          <div className="value">{isClinicClosed ? "停診" : schedule.reservedCount}</div>
        </List>
      </ListWrap>
      {isClinicClosed ? (
        <Alert>本診此日停診　請點任意按鈕回上一頁</Alert>
      ) : (
        <Alert>您尚未完成預約　如需預約請按"我要預約按鈕"</Alert>
      )}
      <div style={{ marginTop: "24px", userSelect: "none" }}>
        <button onClick={onMakeAppointment} disabled={isClinicClosed} style={{ marginRight: "48px"}}>
          {isClinicClosed ? "無法預約" : "我要預約"}
        </button>
        <button onClick={() => history.goBack()}>取消回上頁</button>
      </div>
    </main>
  )
}
